import type { BookingsOverviewAPIResponse } from './types'
import defaultFetch from 'isomorphic-unfetch'
import { BookingsOverviewData } from '../domain/types'
import { bookingsOverviewMapper } from './mappers/bookingsOverviewMapper'

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string
  }
  fetch: typeof defaultFetch
}

function createBookingsOverviewAPIClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    },
    fetch = defaultFetch,
  } = dependencies as Dependencies

  async function getBookingsOverviewData(): Promise<BookingsOverviewData> {
    // TODO:for now contextItemId is hardcoded, we should remove the necessity of passing it, since only used for default image
    try {
      const response = await fetch(
        `${env.NEXT_PUBLIC_API_BASE_URL}/Bookingapi/getself?contextItemId=B1C6F04C-8966-438D-B132-B911AC82852A`,
      )
      const data: BookingsOverviewAPIResponse = await response.json()
      return bookingsOverviewMapper(data)
    }
    catch {
      throw new Error('Failed to fetch bookings overview data')
    }
  }

  return {
    getBookingsOverviewData,
  }
}

export default createBookingsOverviewAPIClient()
